import BaseApiAction from '@Actions/base-api-action';

export default class CreateTeam extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'teams-createTeam',
      payload: {
        name: this._payload.name,
        group: this._payload.group,
        gender: this._payload.gender,
        admins: this._payload.admins,
        license_provider: this._payload.license_provider
      },
    });
  }

  onSuccess(data) {
    this._state.admin.users.events.userCreated.emit();
    super.onSuccess(data);
  }
}
